import { useState, useEffect } from "react";

interface CountdownTimerProps {
	ttl: number;
	onIsRunningChange?: (isRunning: boolean) => void;
}

export default function CountdownTimer({ ttl, onIsRunningChange }: CountdownTimerProps) {
	const [timeLeft, setTimeLeft] = useState(ttl);
	const [isRunning, setIsRunning] = useState(true);

	useEffect(() => {
		if (!isRunning) return;

		const interval = setInterval(() => {
			setTimeLeft((prevTime) => {
				if (prevTime <= 1) {
					clearInterval(interval);
					setIsRunning(false);
					return 0;
				}
				return prevTime - 1;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, [isRunning]);

	useEffect(() => {
		onIsRunningChange?.(isRunning);
	}, [isRunning, onIsRunningChange]);

	const minutes = Math.floor(timeLeft / 60);
	const seconds = timeLeft % 60;

	return (
		<>
			{timeLeft > 0 ? (
				<div className="text-base text-stone-neutral-11">
					Your tickets are reserved for you until:
					<span className="font-bold text-stone-neutral-12 ml-1">
						{minutes}:{seconds < 10 ? `0${seconds}` : seconds}
					</span>
				</div>
			) : (
				<div className="flex flex-wrap text-base">
					<span className="font-medium text-cherry-red-10">
            Reservation time for your tickets has expired, 
            <span className="text-stone-neutral-11"> please close this window and start again to purchase</span>
          </span>
				</div>
			)}
		</>
	);
}
